export default __webpack_public_path__ + "static/media/chicken-bar-chor-mee.bbdbd0f4.png";